import React from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import authActions from '../actions/authActions';

import Theme from './Theme';

class Login extends React.Component {
	constructor(props) {
		super(props);

		// auto logout when this page is hit; therefore it serves also as the "logout" page.
		this.props.dispatch(authActions.logout());

		this.state = {
			user: '',
			pass: '',
			submitted: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const { id, value } = event.target;
		this.setState({ [id]: value });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.setState({ submitted: true });
		this.props.dispatch(authActions.login(this.state.user, this.state.pass));
	}

	render() {
	    const { from } = this.props.location.state || { from: { pathname: "/" } };
	    if (this.props.loggedIn)
	    	return <Redirect to={from} />;

		return <div style={{padding: 12}}>
			<Grid container spacing={24}>
				<Grid item sm={3} md={4}></Grid>
				<Grid item sm={6} md={4}>
					<form onSubmit={this.handleSubmit}>
						<Typography paragraph variant="display3" align="center">foperator</Typography>
						<TextField required autoFocus label="Username" id="user" type="user" fullWidth value={this.state.user} onChange={this.handleChange} style={{marginBottom: Theme.spacing.unit * 2}}></TextField>
						<TextField required label="Password" id="pass" type="password" fullWidth value={this.state.pass} onChange={this.handleChange} style={{marginBottom: Theme.spacing.unit * 4}}></TextField>
						<Typography align="right">
							<Button size="large" variant="raised" color="primary" type="submit" disabled={this.props.loggingIn}>Log in</Button>
						</Typography>
					</form>
				</Grid>
			</Grid>
		</div>;
	}
}

function mapStateToProps(state) {
	const { loggingIn, loggedIn } = state.auth;
	return { loggingIn, loggedIn };
}

export default connect(mapStateToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js